import DataObjectList from '../../../common/model/DataObjectList';

import Contract from './Contract';

export default class ContractList extends DataObjectList {
  getElementClassType() {
    return Contract;
  }
}